// React
import React from 'react';
// PropType
import PropTypes from 'prop-types';

import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';

// redux
import { useDispatch } from 'react-redux';
// MUI
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
// aurora-components
import { ADGMSelect, ADGMPanel, ADGMAlert } from 'aurora-components';
// styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
// Intl
import { injectIntl } from 'react-intl';
import { keyEmptyCheck, formatCurrencyWithoutCurrency } from 'aurora-utils/utils';

import styles from './styles';

const RegistrationFees = ({
  classes,
  title,
  dropDownTitle,
  dropDownData,
  feeText,
  feeSubText,
  totalFeeText,
  adgmAlertText,
  isEditable = false,
  setRegestrationFeesPaidBy,
  additionalDetails,
  additionalSum,
  transactionFeePaidBy,
  paidBy,
  paidByKey,
  feeAmount,
  otherFees,
}) => {
  if (!feeAmount) return null;
  const dispatch = useDispatch();
  const handleInputChange = (key, data) => {
    if (!data) {
      dispatch(
        setRegestrationFeesPaidBy({
          key,
          value: null,
        }),
      );
      return;
    }
    dispatch(
      setRegestrationFeesPaidBy({
        key,
        value: data.value,
      }),
    );
  };
  return (
    <ADGMPanel title={title}>
      <>
        <div className={classes.container}>
          {isEditable && (
            <div className={classes.dropSelectContainer}>
              <ADGMSelect
                type='select'
                label={keyEmptyCheck(dropDownTitle)}
                required
                value={paidBy || ''}
                fullwidth='false'
                name='paidBy'
                onChange={handleInputChange}
                options={dropDownData}
                customClasses={{ select: classes.adgmSelect }}
              />
            </div>
          )}
          {feeAmount && (
            <div className={classes.feeContainer}>
              <div className={classes.feeTextContainer}>
                <Typography className={classes.feeText}>
                  {isString(feeText) ? keyEmptyCheck(feeText) : feeText}
                </Typography>
                {feeSubText && <Typography className={classes.feeSubText}>{keyEmptyCheck(feeSubText)}</Typography>}
                {!isEditable && adgmAlertText && (
                  <ADGMAlert visible noBackground type='mute' className={classes.adgmAlert}>
                    <span>
                      {keyEmptyCheck(adgmAlertText)}
                      {` `}
                      {keyEmptyCheck(paidByKey)}
                    </span>
                  </ADGMAlert>
                )}
              </div>
              <span className={classNames(classes.feeText, classes.feeAmount)}>
                {feeAmount
                  ? keyEmptyCheck('AED_amount', {
                      num: formatCurrencyWithoutCurrency(feeAmount),
                    })
                  : null}
              </span>
            </div>
          )}
          {/* late Fee */}
          {!isEmpty(additionalDetails) &&
            additionalDetails.map(item => {
              return (
                <Box className={classes.otherFees} mt={2}>
                  <div className={classes.additionalDetailsContainer}>
                    <div className={classes.feeTextContainer}>
                      <Typography className={classes.feeText}>
                        {isString(item?.headingText) ? keyEmptyCheck(item?.headingText) : item?.headingText}
                      </Typography>
                      {item?.alertText && (
                        <ADGMAlert visible noBackground type='mute' className={classes.adgmAlert}>
                          <span>
                            {keyEmptyCheck(item?.alertText)}
                            {` `}
                            {keyEmptyCheck(paidByKey)}
                          </span>
                        </ADGMAlert>
                      )}
                    </div>
                    <span className={classNames(classes.feeText, classes.feeAmount)}>
                      {item?.amount
                        ? keyEmptyCheck('AED_amount', {
                            num: formatCurrencyWithoutCurrency(item?.amount),
                          })
                        : null}
                    </span>
                  </div>
                </Box>
              );
            })}
          {/* Showing Other Fees */}
          {!isEmpty(otherFees) && (
            <Box className={classes.otherFees} mt={2}>
              <Box py={1.5} className={classes.feeContainer}>
                <div className={classes.feeTextContainer}>
                  <Typography className={classes.feeText}>{keyEmptyCheck('others')}</Typography>
                </div>
                <span className={classNames(classes.feeText, classes.feeAmount)}>
                  {keyEmptyCheck('AED_amount', {
                    num: formatCurrencyWithoutCurrency(otherFees?.totalAmount),
                  })}
                </span>
              </Box>
              <Box className={classes.feesContainer}>
                <Box component={Grid} container mb={1.5} className={classes.fees}>
                  <Grid item xs={8}>
                    <Typography className={classes.text}>
                      {keyEmptyCheck('electronic_administrative_services_allowance')}
                    </Typography>
                  </Grid>
                  <Box component={Grid} item xs={4} display='flex' justifyContent='flex-end'>
                    <Typography className={classes.text}>
                      {keyEmptyCheck('AED_amount', {
                        num: formatCurrencyWithoutCurrency(otherFees?.amount),
                      })}
                    </Typography>
                  </Box>
                </Box>
                <Box component={Grid} container className={classes.fees}>
                  <Grid item xs={8}>
                    <Typography className={classes.text}>{keyEmptyCheck('vat')}</Typography>
                  </Grid>
                  <Box component={Grid} item xs={4} display='flex' justifyContent='flex-end'>
                    <Typography className={classes.text}>
                      {keyEmptyCheck('AED_amount', {
                        num: formatCurrencyWithoutCurrency(otherFees?.vatCharges),
                      })}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          {feeAmount && (
            <div className={classNames(classes.totalFeeContainer)}>
              <div className={classes.feeContainer}>
                <Typography className={classNames(classes.feeText, classes.feeTextContainer, classes.feeRed)}>
                  {keyEmptyCheck(totalFeeText || 'total_registration_fee_to_be_paid')}
                </Typography>
                <span className={classNames(classes.feeText, classes.feeAmount, classes.feeRed)}>
                  {feeAmount
                    ? keyEmptyCheck('AED_amount', {
                        num: formatCurrencyWithoutCurrency(
                          isEmpty(otherFees) ? feeAmount : feeAmount + otherFees?.totalAmount + additionalSum,
                        ),
                      })
                    : null}
                </span>
              </div>
              <div>
                {transactionFeePaidBy && (
                  <ADGMAlert visible noBackground type='mute' className={classes.adgmAlert}>
                    <span>
                      {keyEmptyCheck('offplan_transaction_fee_paid_by')}
                      {` `}
                      <span className={classes.paidByBold}>{keyEmptyCheck(transactionFeePaidBy)}</span>
                    </span>
                  </ADGMAlert>
                )}
              </div>
            </div>
          )}
        </div>
      </>
    </ADGMPanel>
  );
};
RegistrationFees.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dropDownTitle: PropTypes.string.isRequired,
  dropDownData: PropTypes.array.isRequired,
  feeText: PropTypes.string.isRequired,
  feeSubText: PropTypes.string.isRequired,
  adgmAlertText: PropTypes.string.isRequired,
  totalFeeText: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
  setRegestrationFeesPaidBy: PropTypes.func.isRequired,
  paidBy: PropTypes.string.isRequired,
  paidByKey: PropTypes.string.isRequired,
  feeAmount: PropTypes.number.isRequired,
  otherFees: PropTypes.object,
  additionalDetails: PropTypes.array,
  transactionFeePaidBy: PropTypes.string,
  additionalSum: PropTypes.number,
};

RegistrationFees.defaultProps = {
  otherFees: null,
  transactionFeePaidBy: '',
  additionalDetails: [],
  additionalSum: 0,
};
export default withStyles(styles)(injectIntl(RegistrationFees));
